import {contestCardClickEvent, determineLanguage, displayCard, fillModal, handleClickOnSeeMoreButton, loaderAnimation, removeLoaderAnimation, setActiveTab} from "../common/util";
import {contestStatus, contestType} from "../enum/contest";
import {redirectIfConflict} from "../common/tink";
import {NUMBER_OF_CARDS_ON_LOAD} from '../constants/constants';
import {getTraduction, traductionEnum} from "../common/traduction";
import {pushEventPageView} from "../common/cybermetrie.js";

require("@fancyapps/fancybox");
require("slick-carousel/slick/slick");
require("jquery");
require("jquery-ui");

let seeMoreActiveClicked = false;
let seeMoreClosedClicked = false;
let lang: string = determineLanguage();
let currentActiveContests = 12;
let currentClosedContests = 12;

const CARD_CLASS = '.contest-card';
let $gridInProgress = $('#in-progress-grid');
let $gridClosed = $('#closed-grid');
let $containerWithLoadingAnimation = $('.page-container');
let $seeDetails = $('.page-container-contained .bottom-cta .btn.btn-primary');

$(() => {
    removeLoaderAnimation($('.page-container'));
    $('#main-section').removeClass('hidden');

    // Handle click on tabs for active and closed contests
    bindSeeDetailsButtonClick();
    bindTabEvent();
    bindTabEvent(false);
    bindEventsOnContest(true);
    bindEventsOnContest(false);
    openModalId();

    // Display the right amount of tiles in the grid and return the amount of tile not hidden
    let $seeMoreInProgress = $('#see-more-in-progress');
    let $seeMoreClosed = $('#see-more-closed');
    currentActiveContests = displayCard($gridInProgress, NUMBER_OF_CARDS_ON_LOAD, $seeMoreInProgress, true);
    currentClosedContests = displayCard($gridClosed, NUMBER_OF_CARDS_ON_LOAD, $seeMoreClosed, true);
})

function bindSeeDetailsButtonClick() {
    $seeDetails.on('click', function () {
        let datacId = $(this).attr('data-cid');
        let $selectedContest = $("[data-cid=" + datacId + "]")
        if ($selectedContest.length > 0) {
            // @ts-ignore
            fillModal($selectedContest, activeContests, '#contest-modal-open');
        }
    });
}

//open modal contest with url query
function openModalId() {
    const urlParams = new URLSearchParams(window.location.search);
    let datacId = urlParams.get('datacid')
    datacId = decodeURIComponent(String(datacId));
    let $selectedContest = $("[data-cid=" + datacId + "]")
    if ($selectedContest.length > 0) {
        // @ts-ignore
        fillModal($selectedContest, activeContests, '#contest-modal-open');
    }
}

function bindTabEvent(isTabForActiveContest: boolean = true) {
    // Iterate on tabs for contests
    Object.entries(isTabForActiveContest ? contestType : contestStatus).map(([enumKey, enumValue]) => {
        let prefix = isTabForActiveContest ? 'type_' : 'status_';
        let idSelect = '#' + prefix + enumKey;

        // @ts-ignore
        const url = isTabForActiveContest ? contestUrl + '/type/' + enumValue : contestUrl + '/status/' + enumValue

        $(idSelect).on('click', function () {
            setActiveTab($(this), isTabForActiveContest ? '#contest-open-tab' : '#contest-closed-tab');

            loaderAnimation($containerWithLoadingAnimation, false);

            $.ajax({
                url: url,
                type: 'GET',
                headers: {
                    'Accept-Language': lang
                },
                success: function (data) {
                    replaceCards(data, isTabForActiveContest);
                    bindEventsOnContest(isTabForActiveContest);
                    removeLoaderAnimation($containerWithLoadingAnimation);
                    pushEventPageView();
                },
                error: function (jqXHR) {
                    removeLoaderAnimation($containerWithLoadingAnimation);
                    redirectIfConflict(jqXHR);
                }
            });
        });
    })
}

function bindEventsOnContest(isTabForActiveContest: boolean) {
    // @ts-ignore
    contestCardClickEvent(isTabForActiveContest ? activeContests : finishedContests, '#contest-modal-open');

    seeMoreActiveClicked = false;
    seeMoreClosedClicked = false;
    let $seeMoreInProgress = $('#see-more-in-progress');
    let $seeMoreClosed = $('#see-more-closed');
    // Setting the event on see more button click and enter
    (isTabForActiveContest ? $seeMoreInProgress : $seeMoreClosed).on('click', function () {
        actionOnSeeMoreButton($(this), isTabForActiveContest);
    });

    (isTabForActiveContest ? $seeMoreInProgress : $seeMoreClosed).on('keyup', function (event) {
        if (event.key === 'Enter') {
            actionOnSeeMoreButton($(this), isTabForActiveContest);
            event?.stopPropagation();
        }
    }).on('keydown', function (event) {
        // This prevents the keydown to be called
        if (event.key === 'Enter') {
            event?.preventDefault();
        }
    });
}

function actionOnSeeMoreButton($element: any, isTabForActiveContest: boolean) {

    let $currentContestsContainer = isTabForActiveContest ? $('#in-progress-grid') : $('#closed-grid');
    let isCurrentSeeMoreClicked = isTabForActiveContest ? seeMoreActiveClicked : seeMoreClosedClicked;

    // Display the right amount of tiles in the grid and return the amount of tiles not hidden
    let currentNumberOfContest = handleClickOnSeeMoreButton($element, $currentContestsContainer, isCurrentSeeMoreClicked);

    // Set the number of contests present and not hidden in the section
    isTabForActiveContest ? currentActiveContests = currentNumberOfContest : currentClosedContests = currentNumberOfContest;

    // Button has been clicked
    isTabForActiveContest ? seeMoreActiveClicked = true : seeMoreClosedClicked = true;

    $element.children().first().text(getTraduction(traductionEnum.SEE_MORE_BUTTON_GENERIC_CLICKED));
}

function replaceCards(data: string, isTabForActiveContest: boolean) {
    // Find and replace the html for the loaded fragment
    let $sectionToPutHtmlIn = isTabForActiveContest ? $('#in-progress-container-grid') : $('#closed-container-grid');
    $sectionToPutHtmlIn.replaceWith(data);

    // Reset the button state to see more contests
    isTabForActiveContest ? seeMoreActiveClicked = false : seeMoreClosedClicked = false;
    let $contestsContainer = isTabForActiveContest ? $('#in-progress-grid') : $('#closed-grid');

    // Display the right amount of tiles in the grid and return the amount of tile not hidden
    if (isTabForActiveContest) {
        let $seeMoreInProgress = $('#see-more-in-progress');
        currentActiveContests = displayCard($contestsContainer, NUMBER_OF_CARDS_ON_LOAD, $seeMoreInProgress, true);
    } else {
        let $seeMoreClosed = $('#see-more-closed');
        currentClosedContests = displayCard($contestsContainer, NUMBER_OF_CARDS_ON_LOAD, $seeMoreClosed, true);
    }
}
